(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('internetUsageDailyCtrl', ['$scope', '$log', '$rootScope', '$http', '$filter', 'uteEndpoint', '$timeout', '$stateParams', '$state', 'chartist', 'commonService', function ($scope, $log, $rootScope, $http, $filter, uteEndpoint, $timeout, $stateParams, $state, chartist, commonService) {

      var self = this;

      var monthlyUsageLimit = 0;
      commonService.deepLinkState = '';
      // DC-188: code cleanup, following moved to route resolve

      /* if ($stateParams.accountNumber && $stateParams.subscriberNo) {
        $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
        $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
      } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
        $state.go('myAccount.overview');
      } else {
        if (!$stateParams.accountNumber) {
          $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
        }
        if (!$stateParams.subscriberNo) {
          $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
        }
      } */

      $scope.accountNumber = $stateParams.accountNumber || $rootScope.userInfo.selectedAccountNumber;
      $scope.subscriberNo = $stateParams.subscriberNo || $rootScope.userInfo.selectedSubscriberNo;

      $scope.usageData = [];

      $scope.billingCycleChanged = function () {

        $scope.showCharts = false;

        $http({
          method: 'POST',
          url: uteEndpoint('v3/dailyUsage'),
          data: {
            accountNumber: $scope.accountNumber,
            subscriptionID: $scope.subscriberNo,
            monthIndicator: $scope.selectedMonthIndicator
          }
        })
          .then(function (response) {

            console.log('daily usage:', response);

            var result = response.data;

            $scope.usageData[$scope.selectedMonthIndicator] = {
              sum: {
                upload: 0,
                download: 0
              }
            };

            // daily usage data for table
            // sort by date
            if (result && result.getUsageDetails && result.getUsageDetails.dailyUsageSummary && result.getUsageDetails.dailyUsageSummary.dailyUsage) {
              $scope.usageData[$scope.selectedMonthIndicator].dailyUsage = _.sortBy(result.getUsageDetails.dailyUsageSummary.dailyUsage, function (dailyUsage) {
                return dailyUsage.date;
              });
            }

            if (result && result.getUsageDetails && result.getUsageDetails.dailyUsageSummary && result.getUsageDetails.dailyUsageSummary.totalDailyUsage) {
              var dailyUsageSummaryMB = _.find(result.getUsageDetails.dailyUsageSummary.totalDailyUsage, function (dailyUsage) {
                return dailyUsage.unit === 'MB';
              });
              if (dailyUsageSummaryMB) {
                monthlyUsageLimit = Number(dailyUsageSummaryMB.planLimit);
              }
            }

            var labels = [],
              firstOver = true,
              dailyUnderData = [],
              dailyOverData = [],
              cumulativeChartData = [],
              totalSum = 0;

            _.each($scope.usageData[$scope.selectedMonthIndicator].dailyUsage, function (usage) {

              usage.download = parseInt(usage.download.toFixed(0), 10);
              usage.upload = parseInt(usage.upload.toFixed(0), 10);
              usage.total = parseInt(usage.total.toFixed(0), 10);

              labels.push($filter('date')(usage.date, 'MMM d'));
              $scope.usageData[$scope.selectedMonthIndicator].sum.upload = $scope.usageData[$scope.selectedMonthIndicator].sum.upload + usage.upload;
              $scope.usageData[$scope.selectedMonthIndicator].sum.download = $scope.usageData[$scope.selectedMonthIndicator].sum.download + usage.download;

              totalSum += usage.total;

              cumulativeChartData.push(totalSum);

              if (totalSum <= monthlyUsageLimit) {

                dailyUnderData.push(usage.total);
                dailyOverData.push(null);

              } else if (totalSum > monthlyUsageLimit && firstOver) {

                dailyUnderData.push(usage.total);
                dailyOverData.push(usage.total);
                firstOver = false;

              } else if (totalSum > monthlyUsageLimit && !firstOver) {

                dailyUnderData.push(null);
                dailyOverData.push(usage.total);

              }

            });

            $scope.usageData[$scope.selectedMonthIndicator].cumulativeLimitOptions = {
              enabled: monthlyUsageLimit !== 9999999,
              limit: monthlyUsageLimit
            };

            /**
             * @description daily chart data
             */
            $scope.usageData[$scope.selectedMonthIndicator].lineDailyData = {
              labels: labels,
              series: [
                dailyUnderData,
                dailyOverData
              ]
            };

            /**
             * @description cumulative chart data
             */
            $scope.usageData[$scope.selectedMonthIndicator].lineCumulativeData = {
              labels: labels,
              series: [
                {
                  data: cumulativeChartData
                }
              ]
            };

            if (angular.isDefined($scope.lineCumulativeOptions.plugins)) {
              delete $scope.lineCumulativeOptions.plugins;
            }

            $scope.lineCumulativeOptions.plugins = [
              chartist.plugins.ctThreshold({
                threshold: monthlyUsageLimit,
                ignoreClass: ['ute-limit-line']
              })
            ];

            $scope.showCharts = true;


            if (dailyUnderData && (dailyUnderData || []).length > 0) {
              $scope.dailyChartStatus = 'SUCCESS';
            } else {
              if (result && result.getUsageDetails && result.getUsageDetails.error) {
                $scope.dailyChartStatus = 'ERROR';
              } else {
                $scope.dailyChartStatus = 'NO-DATA';
              }
            }

            if (cumulativeChartData && (cumulativeChartData || []).length > 0) {
              $scope.cumulativeChartStatus = 'SUCCESS';
            } else {
              if (result && result.getUsageDetails && result.getUsageDetails.error) {
                $scope.cumulativeChartStatus = 'ERROR';
              } else {
                $scope.cumulativeChartStatus = 'NO-DATA';
              }
            }

          }, function () {
            $scope.dailyChartStatus = 'ERROR';
            $scope.cumulativeChartStatus = 'ERROR';
          });


        /**
         * @description daily usage options
         */
        $scope.lineDailyOptions = {
          showPoint: false,
          fullWidth: true,
          height: 200,
          lineSmooth: false,
          low: 0,
          chartPadding: {
            right: 10
          },
          axisY: {
            labelOffset: {
              x: 0,
              y: 5
            },
            labelInterpolationFnc: function (value, index, axis) {
              if (index === axis.length - 1) {
                return $filter('uteCapacityUnit')(value) + '<br/>' + $filter('uteCapacity')(value, false, false);
              } else {
                return $filter('uteCapacity')(value, false, false);
              }
            }
          },
          axisX: {
            showGrid: true,
            labelInterpolationFnc: function (value, index, axis) {
              // only show the first and last label
              if (index === 0 || index === axis.length - 1) {
                return value;
              } else if (index % 1 === 0) {
                return ' ';
              } else {
                return false;
              }
            }
          }
        };

        /**
         * @description cumulative chart options
         */
        $scope.lineCumulativeOptions = {
          showPoint: false,
          fullWidth: false,
          height: 200,
          low: 0,
          lineSmooth: false,
          axisY: {
            labelOffset: {
              x: 0,
              y: 5
            },
            labelInterpolationFnc: function (value, index, axis) {
              if (index === axis.length - 1) {
                return $filter('uteCapacityUnit')(value) + '<br/>' + $filter('uteCapacity')(value, false, false);
              } else {
                return (index % 1 === 0) && $filter('uteCapacity')(value, false, false);
              }
            }
          },
          axisX: {
            showGrid: false,
            labelOffset: {
              x: 0,
              y: 0
            },
            labelInterpolationFnc: function (value, index, labels) {
              // only show the first and last label
              if (index === 0 || index === labels.length - 1) {
                return value;
              } else if (index % 1 === 0) {
                return ' ';
              } else {
                return false;
              }
            }
          }
        };
      };

      self.loopBillingCycle = function () {
        $scope.usageData.push({
          sum: {
            upload: 0,
            download: 0
          },
          cumulativeLimitOptions: {
            enabled: false
          }
        });
      };

      self.usageSummaryLoaded = function (resp) {
        if (resp && resp.data && resp.data.getDataHSIUsageSummary) {
          $scope.usageSummary = resp.data.getDataHSIUsageSummary;
        } else {
          $scope.usageSummary = { error: '50000' };
          $scope.dailyChartStatus = "ERROR";
          $scope.cumulativeChartStatus = "ERROR";
        }

        $scope.usageSummary.usageMeter = Math.round($scope.usageSummary.usageMeter);

        if ($scope.usageSummary && $scope.usageSummary.usageMeter > 100) {
          $scope.usageSummary.usageMeter = 100;
        }

        $scope.usageData = [];

        _.each($scope.usageSummary.billingCycle, self.loopBillingCycle);

        if ($scope.usageSummary && $scope.usageSummary.billingCycle && $scope.usageSummary.billingCycle.length) {
          $scope.selectedMonthIndicator = $scope.usageSummary.billingCycle[0].monthlyInd;
          $scope.billingCycleChanged();
        }

      };

      self.init = function () {
        $scope.dailyChartStatus = 'LOADING';
        $scope.cumulativeChartStatus = 'LOADING';

        var summaryUrl = uteEndpoint('v1/productConsolidatedUsageSummary');

        $http.post(summaryUrl, {
          prodSpec: 'hsi',
          accountNumber: $scope.accountNumber,
          subscriptionID: $scope.subscriberNo
        }).then(
          self.usageSummaryLoaded,
          function () {
            $scope.usageSummary = { error: '50000' };
            $scope.dailyChartStatus = "ERROR";
            $scope.cumulativeChartStatus = "ERROR";
        });
      };

      self.init();

    }]);

})();
